import React from "react";
import { Redirect } from "react-router-dom";
import MobileFilters from "../components/Dishes/MobileFilters";
import Filters from "../components/Dishes/Filters";
import PageDishes from "../components/Dishes/PageDishes";
import { UserContext } from "../context/user";
import { DishesContext } from "../context/dishes";
import PizzaLoading from '../strapi/loading-gifs/Pizza-loading'
import BestDeals from '../components/BestDeals';
import {FixedDiv,Button} from '../components/Layout/Elements'

const Dishes = () => {
  const { user,loading } = React.useContext(UserContext);
  const { phone_screen, bestdeals} = React.useContext(DishesContext);

  const [best,setBest] = React.useState(false)
  const [click, setClick] = React.useState(false)
  const handleBest = () => {
    setBest(!best)
  }

  const handleClick = () => {
    setClick((prevState) => !prevState);
  }

  if (loading) {
    return <PizzaLoading />
  }
  else {
return (
    <div className='grid-filters'>
      <div className='grid-1'>
        { phone_screen ? <MobileFilters click={click} handleClick={handleClick} handleBest={handleBest} /> : <Filters   /> }
      </div>
      { phone_screen && 
        <FixedDiv visible={best}>
          <h5>Best Deals</h5>
          {bestdeals.map((item) => {
            return <BestDeals key={item.id} {...item} />
          })}
          <Button bg='var(--navbar-bg)' fontSize='14px' fontWeight='bold'  padding='10px' color='white' width='100%'  onClick={handleBest}>Go back</Button>
        </FixedDiv>
      }
      <div className='grid-2'>
     { user.token ? <PageDishes handleClick={handleClick} /> : <Redirect to='/login'></Redirect> }
      </div>
    </div>
  );
  }
};

export { Dishes as default };
